import { Dialog, Text, Box } from "@radix-ui/themes";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/Tabs/Tabs";
import { Separator } from "../../../ui/Separator";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import { Division, ProducerById } from "../../../types/types";
import DivisionStaffTab from "./tabs/DivisionStaffTab";
import DivisionSettingsTab from "./tabs/DivisionSettingsTab";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import Spinner from "../../../ui/Spinner/Spinner";
import { TbArrowLeft } from "react-icons/tb";

type Props = {
  //equipments: Equipment[] | null;
};

const DivisionItem = (props: Props) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/directories/divisions/${id}`);

  useEffect(() => {
    if (!id) {
      return;
    }
    setLoading(true);
    doFetchItem();
  }, [id]);

  useEffect(() => {
    updateDivision();
  }, []);

  const updateDivision = () => {
    doFetchItem();
  };

  //   const doFetchRefresh = useRefreshEquipments();
  //   useEffect(() => {
  //     if (itemUpdateResponse) doFetchRefresh();
  //   }, [itemUpdateResponse]);

  useEffect(() => {
    if (!response) {
      return;
    }
    setCurrentDivision(response.data as unknown as Division);
    setLoading(false);
  }, [response]);

  const [currentDivision, setCurrentDivision] = useState<Division>();

  // return loading ? (
  //   <Spinner />
  // ) : (
  //   <>
  //     <Tabs defaultValue="settings" className="flex flex-col h-full w-full">
  //       <TabsList className="flex-none flex w-full h-12 bg-background">
  //         <div className="flex w-full max-w-[900px] justify-start mx-auto pl-4 pr-16">
  //           <TabsTrigger className="data-[state=active]:bg-muted data-[state=active]:text-foreground" value="settings">
  //             {t("settings")}
  //           </TabsTrigger>
  //           <TabsTrigger className="data-[state=active]:bg-muted data-[state=active]:text-foreground" value="info">
  //             {t("staff")}
  //           </TabsTrigger>
  //         </div>
  //       </TabsList>
  //       <Separator />
  //       <ScrollArea>
  //         <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden mb-20">
  //           <TabsContent value="settings">
  //             <DivisionSettingsTab id={id} currentDivision={currentDivision} />
  //           </TabsContent>
  //           <TabsContent value="info">
  //             {currentDivision ? <DivisionMainTab id={id} currentDivision={currentDivision} /> : ""}
  //           </TabsContent>
  //         </div>
  //       </ScrollArea>
  //     </Tabs>
  //   </>
  // );

  return loading ? (
    <Spinner />
  ) : (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full h-full max-w-[800px]">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={"/data/divisions"} className="text-sm flex gap-2 items-center text-muted-foreground"><TbArrowLeft />{t("divisions")}</NavLink>
            <span className="text-2xl font-semibold">{t('editing_division')}</span>
          </div>
        </div>
        <Tabs defaultValue="settings">
          <div className="px-6">
          <TabsList className="w-full flex-none h-10 justify-between px-2 rounded">
            <div className="flex">
              <TabsTrigger value="settings">{t("settings")}</TabsTrigger>
              <TabsTrigger value="staff">{t("staff")}</TabsTrigger>
            </div>
          </TabsList>
          </div>
          <TabsContent value="settings">
              <DivisionSettingsTab id={id} currentDivision={currentDivision} />
            </TabsContent>
            <TabsContent value="staff">
              {currentDivision ? <DivisionStaffTab id={id} currentDivision={currentDivision} /> : ""}
            </TabsContent>
        </Tabs>
      </div>
    </ScrollArea>
  );
};

export default DivisionItem;
